'use client'
import { useSession } from 'next-auth/react'

export default function Layout() {
  const session = useSession()
  if (session.status === 'authenticated') return true
  return false
}
